
<template>
  <div class="page-wrapper">
    <NavBar class="style1" />
    <div class="content-wrapper">
      <PageTitle pageTitle="Notre Revue" />
      <NotreRevue />
    </div>
    <FooterComp />
  </div>
</template>

<script>
import NavBar from '../Layouts/NavBar.vue'
import PageTitle from '../Common/PageTitle.vue'
import FooterComp from '../Layouts/FooterComp.vue'
import NotreRevue from '../Revue/NotreRevue.vue'


export default {
  name: 'NotreRevuePage',
  components: {
    NavBar,
    PageTitle,
    NotreRevue,
    FooterComp,
  }
}
</script>